module.exports = "/packs/images/svg/ireland/facilities/tracks~f657134ff06d8c9a4bac32b39163f421.svg";